import xss from 'xss'

// 处理xss攻击
const xssObj = new xss.FilterXSS({
  onIgnoreTagAttr: (tag, name, value) => {
    if (['style', 'class'].includes(name)) {
      return `${name}="${xss.escapeAttrValue(value)}"`
    }
  }
})

export const getXssIntro = (str) => xssObj.process(str || '')
